<template>
  <div>
    <Button type="primary" @click="modal1 = true">新增</Button>

    <Table :columns="columns10" :data="data9"> </Table>

    <Modal
      v-model="modal1"
      title="新增banner"
      width="1000"
      :loading="loading"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="是否需要用户信息">
            <Checkbox v-model="istoken">是</Checkbox>
          </FormItem>
          <FormItem label="类型">
            <RadioGroup v-model="ntype">
              <Radio label="0">banner</Radio>
              <Radio label="1">公告</Radio>
              <Radio label="2">限时任务</Radio>
            </RadioGroup>
          </FormItem>

          <FormItem label="开始时间">
            <DatePicker
              v-model="createtime"
              type="datetime"
              placeholder="Select date and time"
              style="width: 200px"
            ></DatePicker>
          </FormItem>
          <FormItem label="结束时间">
            <DatePicker
              type="datetime"
              v-model="extime"
              placeholder="Select date and time"
              style="width: 200px"
            ></DatePicker>
          </FormItem>
          <FormItem label="排序(数字越大越靠前)">
            <InputNumber :max="100" :min="1" v-model="nsort"></InputNumber>
          </FormItem>
          <FormItem label="等级">
            <Input placeholder="lv" v-model="lv"></Input>
          </FormItem>
          <FormItem label="跳转链接,1是跳转商店,2是跳转充值">
            <Input placeholder="请输入跳转链接" v-model="surl"></Input>
          </FormItem>
          <single-upload title="上传封面图" @update:image="updateimage1" />
          <single-upload title="上传跳转详情图" @update:image="updateimage2" />

        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
import SingleUpload from "@/components/Upload/singleUpload";
import { cmsBannerList, addBanner, delBanner } from "../../api/banner";
import { formatOssUrl } from "@/utils";

const OSS = require("ali-oss");
var ossClient = null;
export default {
  components: { SingleUpload },
  data() {
    return {
      modal3: false,
      searchDate: [],
      surl: "",
      istoken: "0",
      ntype: "0",
      imgurl: "",
      createtime: "",
      extime: "0",
      nsort: 1,
      loading: true,
      modal1: false,
      lv: "", //小板id
      imgurl: 1, //小板座位号
      clickmachineid: "",
      videourl1: "",
      videourl2: "",
      columns10: [
        {
          title: "封面图",
          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.imgurl)  ,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "是否需要用户信息",
          key: "istoken",
        },
        {
          title: "类型",
          key: "ntype",
          render: (h, params) => {
            var machinetype = params.row.ntype == "0" ? "banner" : "公告";
            return h("span", machinetype);
          },
        },
        {
          title: "跳转链接",
          key: "surl",
        },

        {
          title: "开始时间",
          key: "createtimes",
        },
        {
          title: "结束时间",
          key: "extimes",
        },
        {
          title: "排序(数字越大越靠前)",
          key: "nsort",
        },
        {
          title: "等级",
          key: "lv",
        },

        {
          title: "状态",
          key: "status",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.delBanner(params.row.id);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      data9: [],
    };
  },
  mounted() {
    this.selmachine();
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    updateimage1(value) {
      this.imgurl = value;
      console.log("updateimage1" + value);
    },
    updateimage2(value) {
      this.surl = process.env.OSS + value;
      console.log("updateimage2" + value);
    },
    selmachine() {
      cmsBannerList({}).then((res) => {
        console.log("===" + JSON.stringify(res));

        this.data9 = res.data;
      });
    },
    delBanner(id) {
      delBanner({ id }).then((res) => {
        this.selmachine();
      });
    },

    ok() {
      console.log(
        this.ntype,
        this.istoken,
        this.createtime,
        this.extime,
        this.nsort,
        this.lv,
        this.surl,
        this.imgurl
      );
      addBanner({
        createtime: this.createtime,
        istoken: this.istoken == "true" ? 1 : 0,
        ntype: this.ntype,
        extime: this.extime,
        lv: this.lv,
        nsort: this.nsort,
        imgurl: this.imgurl,
        surl: this.surl,
      }).then((res) => {
        this.modal1 = false;
        this.selmachine(); 
      });
    },
    cancel() {
      this.$Message.info("Clicked cancel");
    },
    updateMachineStatus(status) {
      updateMachineStatus({ status: status, roomid: this.clickmachineid }).then(
        (res) => {
          this.selmachine();
        }
      );
    },
    guanbimodal() {
      this.modal3 = false;
    },
  },
};
</script>
